{
  "allRequired": "Alle felt må fyllast ut",
  "requiredField": "Må fyllast ut",
  "optional": "Valfritt",
  "allOptional": "Alle felt er valfrie",
  "requiredRadiobuttonList": "Vel éin",
  "requiredCheckboxList": "Vel éin eller fleire",
  "requiredSingleCheckbox": "Må veljast"
}
